import {
  ADMIN_LOGOUT,
  PARTNER_REVIEW_CHANGE_VALUES,
  PARTNER_REVIEW_ORDER_SET,
} from '@shared/store/constants/mutationTypes';
import initialState from './partnerReviewInitialState';

const mutations = {
  [PARTNER_REVIEW_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
  [PARTNER_REVIEW_ORDER_SET]: (state, payload) => {
    const {
      order,
      paymentPending,
      invoicePaymentMethod,
    } = payload;
    state.order = order;
    state.paymentPending = paymentPending;
    state.invoicePaymentMethod = invoicePaymentMethod;
    state.loadingOrder = false;
  },
  [ADMIN_LOGOUT]: (state) => {
    Object.assign(state, initialState());
  },
};

export default mutations;
